import { byId, h } from './dom';

/** Minimal modal system: one modal at a time, Esc/backdrop closes non-critical ones. */

let current: { el: HTMLElement; onClose?: () => void } | null = null;

export interface ModalOptions {
  dismissible?: boolean;
  onClose?: () => void;
}

export function openModal(content: HTMLElement, opts: ModalOptions = {}): () => void {
  closeModal();
  const box = h('div', { class: 'modal', role: 'dialog', 'aria-modal': 'true' }, content);
  const backdrop = h('div', { class: 'modal-backdrop' }, box);
  if (opts.dismissible !== false) {
    backdrop.addEventListener('pointerdown', (e) => { if (e.target === backdrop) closeModal(); });
  }
  byId('modal-root').append(backdrop);
  current = { el: backdrop, ...(opts.onClose ? { onClose: opts.onClose } : {}) };
  const focusable = box.querySelector<HTMLElement>('input, button');
  focusable?.focus();
  return closeModal;
}

export function closeModal(): void {
  if (!current) return;
  const c = current;
  current = null;
  c.el.remove();
  c.onClose?.();
}

export function modalOpen(): boolean {
  return current !== null;
}

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && current) closeModal();
});

export function confirmModal(title: string, body: string, confirmLabel: string, onConfirm: () => void, danger = false): void {
  openModal(h('div', {},
    h('h2', { text: title }),
    h('p', { text: body }),
    h('div', { class: 'actions' },
      h('button', { class: 'btn secondary', type: 'button', onclick: () => closeModal() }, 'Cancel'),
      h('button', { class: `btn ${danger ? 'danger' : ''}`, type: 'button', onclick: () => { closeModal(); onConfirm(); } }, confirmLabel),
    ),
  ));
}
